import script from "./BannerComp.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerComp.vue?vue&type=script&setup=true&lang=js"

import "./BannerComp.vue?vue&type=style&index=0&id=6e7e0652&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e7e0652"]])

export default __exports__